import './main-menu-global-search-item.component.scss';

export default {
  template: require('./main-menu-global-search-item.component.html'),
  bindings: {
    href: "@?vuiHref",
    title: "@?vuiTitle"
  },
  transclude: true,
  controller: function () {
    'ngInject';
  }
};
